<template>
  <div class="card main-content">

    <div class="grid w-full">        
        <div class="sm:col-12 md:col-12 lg:col-12">
          <div class="flex w-full">
            <div class="flex-initial flex justify-content-center w-full"> 
                <div class="surface-card shadow-2 p-3 border-round-xl  w-full mt-4 mr-2 ml-3">

                    <div class="flex flex-wrap align-items-center justify-content-between ">
                        <span class="mt-2">
                            <label class="text-xl font-semibold">Non Roc Items</label>
                        </span>
                        <span class="mt-2">
                            <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
                        </span>
                    </div>
                    <div class="flex flex-wrap align-items-center justify-content-between my-2">
                        <span >
                            <router-link to="/non-roc" rel="noopener">
                                <Button icon="pi pi-plus" label="New Item" size="small" raised   v-tooltip.top="'Create New Item'" @click="showDialog(null, 0)"/>
                            </router-link>
                        </span>
                        <span class="mt-2">
                            <!-- <Button class="ml-2" icon="pi pi-filter-slash" size="small" outlined severity="success" @click="clearFilter" v-tooltip.top="'Clear Filter'"/> -->
                        </span>
                    </div>

            <DataTable :value="nonRocData" :loading="loading" :size="small" tableStyle="min-width: 50rem" paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" scrollable scrollHeight="65vh" v-model:filters="filters" >
                <Column header="Sl No." style="width:2%">
                    <template #body="slotProps">
                        {{slotProps.index + 1}}
                    </template>
                </Column>
                <Column field="name" header="Item" >
                    <template #body="slotProps">
                        {{slotProps.data.name}}
                    </template>
                    <!-- <template #filter="{ filterModel }">
                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Filter by DEPT" />
                    </template> -->
                </Column>
                <Column field="rate" header="Old Rate" >
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.rate)}}
                    </template>
                </Column>
                <Column field="basic" header="Basic" >
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.basic)}}
                    </template>
                </Column>
                <Column field="oldGst" header="Old GST" >
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.oldGst)}}
                    </template>
                </Column>                
                <Column field="gst2" header="GST 2.0(%)" >
                    <template #body="slotProps">
                        {{slotProps.data.gst2}}
                    </template>
                </Column>
                <Column field="newRate" header="New Rate" >
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.newRate)}}
                    </template>
                </Column>
                <Column field="packing" header="Packing" >
                    <template #body="slotProps">
                        {{slotProps.data.packing}}
                    </template>
                </Column>
                <Column field="category.label" header="Category" >
                    <template #body="slotProps">
                        {{slotProps.data.category.label}}
                    </template>
                </Column>
                <Column field="refNo" header="Ref No." >
                    <template #body="slotProps">
                        {{slotProps.data.refNo}}
                    </template>
                </Column>
                <Column  header="Action" >
                    <template #body="slotProps">
                        <Button label="Update" severity="help" size="small" raised @click="showDialog(slotProps.data, 1)"></Button>
                    </template>
                </Column>
            </DataTable>

                </div>
            </div>
          </div>
        </div>
    </div>
  </div>

  <Dialog :visible="visibility1" :header="dialogHeader" :modal="true" :style="{ width: '60rem' }" :closable="false" :dismissableMask="true">

    <!-- <template #header>
        <div class="flex align-items-center justify-content-between w-full">
            <span class="text-xl font-semibold">Non Roc Item</span>
        </div>
    </template> -->

    <span class="text-sm text-400">Options marked as <span class="text-red-500">*</span> are mandatory</span>

    <div class="formgrid grid mt-2">
        <div class="field col">
            <label for="itemName">Name:<span class="text-red-500">*</span></label>
            <InputText v-model="itemName" class="w-full" placeholder="Name of the item"/>
        </div>            
        <div class="field col">
            <label for="itemPacking">Packing:<span class="text-red-500">*</span></label>
            <InputText v-model="itemPacking" class="w-full" placeholder="Packing of the item"/>
        </div>
        <div v-if="isUpdate" class="field col">
            <label >Old Rate:</label>
            <InputNumber v-model="oldRate" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" variant="filled" readonly/>
        </div>
    </div>

    <div class="formgrid grid mt-2">
        
        <div class="field col">
            <label >Basic:<span class="text-red-500">*</span></label>
            <InputNumber v-model="itemBasic" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" @input="updateBasic"/>
        </div>
        <div class="field col">
            <label >GST 2.0 (%):<span class="text-red-500">*</span></label>
            <InputNumber v-model="itemGst" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" @input="updateGst"/>
        </div>
        <div class="field col">
            <label >New Rate 2.0:<span class="text-red-500">*</span></label>
            <InputNumber v-model="newRate" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" variant="filled" readonly/>
        </div>
    </div>

    <div class="formgrid grid mt-2" >
        
        <div :class="`field ${isEquipment==true? 'col-4' : 'col-4'}`">
            <label for="itemcategory">Category:<span class="text-red-500">*</span></label>
            <Dropdown v-model="itemCategory" :options="categories" optionLabel="label" optionValue="key" placeholder="Select Category" class="w-full" @change="checkCategory"/>
        </div>
        <div v-if="isEquipment" class="field col-3">
            <label for="installationStatus">Installation Reqd:</label>
            <Dropdown class="w-full" size="small" v-model="installationStatus" :options="installationOptions" optionValue="value" optionLabel="label" placeholder="Select an option"/>
        </div>
        <!-- <div :class="`field ${isEquipment==true? 'col-3' : 'col-4'}`">
            <label for="itemManufacturer">Manufacturer:</label>
            <Dropdown size="small" class="w-full" v-model="itemManufacturer"    :options="manufacturers" optionValue="id" optionLabel="name" placeholder="Select Manufacturer"/>
        </div> -->
        <div class="field col-4">
            <label >Ref No.:</label>
            <InputText v-model="itemRef" class="w-full" placeholder="Quotation/Ref No."/>
        </div>
    </div>

    <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <div class="flex align-items-center justify-content-center">
                
                <Button v-if="!isUpdate" label="Save" raised severity="success" size="small" class="mx-2" @click="saveItem" ></Button>
                <Button v-if="isUpdate" label="Update" raised severity="success" size="small" class="mx-2" @click="updateItem"></Button>
                <Button label="Cancel" text raised severity="secondary" size="small" @click="visibility1=false"></Button>
            </div>
        </div>
    </template>
  </Dialog>
</template>

<script>
import { getCategories, getManufacturers, getNonRocItems, storeNonRocItem, updateNonRocItem } from '@/services/apiService';
import Button from 'primevue/button';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import { FilterMatchMode } from 'primevue/api'

export default {
    components: {
        Button,
        DataTable,
        Column,
        InputText,
        Dialog,
        Dropdown,
        InputNumber,
    },
    data(){
        return{
            nonRocData:[],
            loading:false,
            filterQuery:null,
            visibility1:false,
            isUpdate:false,
            itemName:null,
            itemPacking:null,
            itemBasic:0,
            itemGst:0,
            newRate:0,
            oldRate:0,
            itemCategory:null,
            installationStatus:null,
            itemManufacturer:null,
            itemRef:null,
            installationOptions:[
                {label:'No', value:'0'},
                {label:'Yes', value:'1'},
            ],
            manufacturers:[],
            isEquipment:false,
            categories:[],
            itemId:null,
            dialogHeader:'New Non Roc Item',
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.IN },  
                basic: { value: null, matchMode: FilterMatchMode.IN },  
                gst2: { value: null, matchMode: FilterMatchMode.IN },  
                newRate: { value: null, matchMode: FilterMatchMode.IN },  
                'category.label': { value: null, matchMode: FilterMatchMode.IN },  
                refNo: { value: null, matchMode: FilterMatchMode.IN },  
            },
        }
    },
    mounted(){
        this.fetchNonRocData();
        this.fetchCategories();
    },
    methods:{
        async fetchNonRocData(){
            this.loading = true;
            try {
                const res = await getNonRocItems();
                this.nonRocData = res.data;
                this.loading = false;
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.loading = false;
            }
        },
        showDialog(item, mode){
            if(item==null && mode==0){
                this.isUpdate = false;
                this.dialogHeader = 'New Non Roc Item';
            }
            else if(item!=null && mode==1){
                
                this.dialogHeader = 'Update: '+item.name;
                this.isUpdate = true;
                this.itemId = item.id;
                this.itemName = item.name;
                this.itemPacking = item.packing;
                this.itemBasic = item.basic;
                this.itemGst = item.gst2;
                this.newRate = item.newRate;
                this.itemCategory = item.category.key;
                this.itemRef = item.refNo;
                this.oldRate = item.rate;
                this.installationStatus = item.installationStatus;
                this.checkCategory();
            }
            this.visibility1 = true;
        },
        async saveItem(){
            if(this.installationStatus==null && this.isEquipment){
                return this.showErrorToast({'message':'Equipment installation status is required!'});
            }
            if(this.itemName==null || this.itemPacking==null || this.itemCategory==null || this.itemBasic==0 || this.itemGst==0 || this.newRate==0){
                return this.showErrorToast({'message':'Fields marked with * are required!'});
            }

            const data ={
                'name':this.itemName,
                'basic':this.itemBasic,
                'gst2':this.itemGst,
                'newRate':this.newRate,
                'packing':this.itemPacking,
                'category':this.itemCategory,
                'installationStatus':this.installationStatus,
                'manufacturer':this.itemManufacturer,
                'refNo':this.itemRef,
            }

            try {
                const res = await storeNonRocItem(data);
                this.showSuccessToast(res.data);
                this.visibility1 = false;
                this.fetchNonRocData();  
                this.clearDialog();                              
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.visibility1 = false;
            }
        },
        async updateItem(){
            if(this.newRate==0){
                return this.showErrorToast({'message':'Rate cannot be ZERO (0)'});
            }
            if(this.itemCategory==null){
                return this.showErrorToast({'message':'Category is required!'});
            }
            const data ={
                'itemId':this.itemId,
                'name':this.itemName,
                'oldRate':this.oldRate, //used previously during old gst regime
                'oldGst':this.oldRate>0 ? Math.round((((this.oldRate - this.itemBasic)/this.itemBasic) * 100), 2) : 0,
                'basic':this.itemBasic,
                'gst2':this.itemGst,
                'newRate':Math.round(this.newRate * 10000) / 10000,
                'packing':this.itemPacking,
                'category':this.itemCategory,
                'installationStatus':this.installationStatus,
                'manufacturer':this.itemManufacturer, //presently it's null. Can be enable to use to update manufacturer also
                'refNo':this.itemRef,
            }
            
            try {
                const res = await updateNonRocItem(data, this.itemId);
                this.showSuccessToast(res.data);
                this.visibility1 = false;
                this.fetchNonRocData(); 
                this.clearDialog();
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.visibility1 = false;
            }

        },
        async fetchCategories(){
            try {
                const res = await getCategories();
                this.categories = res.data;

                this.equipCategory = (this.categories.find((category) => {
                    if(category.label == 'Equipments' || category.label == 'Equipment' || category.label == 'EQUIPMENTS' || category.label == 'EQUIPMENT'){
                        return category;
                    }
                })).key;
                
            } catch (error) {
                this.showErrorToast(error.response.data);
                
            }
        }, 
        async fetchManufacturers(){
            try {
                const res = await getManufacturers();
                this.manufacturers = res.data;
                
            } catch (error) {
                this.showErrorToast(error.response.data);
            }
        },
        updateGst(event){
            this.itemGst = event.value;
            this.updateRate();
        },
        updateBasic(event){
            this.itemBasic = event.value;
            this.updateRate();
        },
        updateRate(){
            this.newRate = this.itemBasic + (this.itemBasic * (this.itemGst/100));
        }, 
        checkCategory(){            
            if(this.itemCategory == this.equipCategory){
                this.isEquipment = true;
                this.installationStatus = '1';
            }else{
                this.isEquipment = false;
                this.installationStatus = '0';
            }        
        }, 
        clearDialog(){
            this.itemId = null;
            this.itemName = null;
            this.oldRate = 0;
            this.itemBasic = 0;
            this.itemGst = 0;
            this.newRate = 0;
            this.itemPacking = null;
            this.itemCategory = null;
            this.installationStatus = null;
            this.itemManufacturer = null;
            this.itemRef = null;
        },     
        formatCurrency(value) {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }, {maximumFractionDigits:4, minimumFractionDigits:2});
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
    }

}
</script>

<style>

</style>